import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { genderAndBirthdateActions } from './gender-and-birthdate.actions';
import { map } from 'rxjs/operators';
import {profileApiActions} from "@fitup-monorepo/core/lib/state/profile/profile.actions";

@Injectable()
export class GenderAndBirthdateEffects {
  private readonly actions$ = inject(Actions);

  public readonly updateCustomer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(genderAndBirthdateActions.updateCustomer),
      map(customer => profileApiActions.updateCustomer(customer))
    )
  );
}
